
ADILF.define('adilf/util/article-stub',['require','exports','module','streamhub-sdk/collection'],function (require, exports, module) {'use strict';

var Collection = require('streamhub-sdk/collection');

var REQUIRED_ARTICLE_STUB_EXTENSIONS = ['networkId', 'siteId', 'articleId'];

var articleStub = {};

/**
 * Return true if the content should be considered an article stub
 */
articleStub.test = function (content) {
    content.meta.content.annotations = content.meta.content.annotations || {};
    var extensions = (content.extensions) ? content.extensions : (content.meta.content.annotations.extension) ? content.meta.content.annotations.extension : {};
    var numReqExtensions = REQUIRED_ARTICLE_STUB_EXTENSIONS.length;
    var extensionName;
    var extensionValue;
    for (var i=0; i<numReqExtensions; i++) {
        extensionName = REQUIRED_ARTICLE_STUB_EXTENSIONS[i];
        extensionValue = extensions[extensionName];
        if ( ! extensionValue) {
            return false;
        }
    }
    return extensions;
};

/**
 * Test whether a piece of content is renderable as an article stub
 * That is, does it have the expected Content Extensions
 * If so, return the Collection that has replies to the article root
 */
articleStub.getRepliesCollection = function (content) {
    var extensions = this.test(content);
    if ( ! extensions) {
        return null;
    }
    var collectionOpts = {
        network: extensions.networkId,
        siteId: extensions.siteId,
        articleId: extensions.articleId,
        collectionMeta: extensions.collectionMeta
    };
    if ( ! validateCollectionOpts(collectionOpts)) {
        return false;
    }
    // All required extensions are present to make a replies Collection
    var repliesCollection = new Collection(collectionOpts);
    return repliesCollection;
};

// Extra validation. Useful while devving.
// Even if the required extensions are there, they may be silly values
// This returns false if there are silly values
function validateCollectionOpts(opts) {
    if (opts.network === '1') {
        return false;
    }
    return true;
}

module.exports = articleStub;
});
